<form [formGroup]="parentFormGroup">
  <mat-form-field class="categories-selector-control">
    <mat-select multiple [formControlName]="controlName">
      @for (item of categories$ | async; track item.categoryId) {
        <mat-option [value]="item.categoryId">
          {{item.categoryLabel}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</form>
